import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { SaveAccountPayload, updateAccount, UpdateAccountResponse } from '../query-api'

interface UseUpdateExistingAccountProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: UpdateAccountResponse) => void
}

export const useUpdateExistingAccount = (props: UseUpdateExistingAccountProps = {}) => {
  const { onError, onSuccess } = props || {}

  const { mutate: updateExistingAccount, isLoading: isProcessing } = useMutation(
    (accountData: Partial<SaveAccountPayload>) => updateAccount(accountData),
    {
      onError: (error: APIError) => {
        onError?.(error)
      },
      onSuccess: (data: UpdateAccountResponse) => {
        onSuccess?.(data)
      },
    },
  )

  return { updateExistingAccount, isProcessing }
}
